
import moment from 'moment';

import {
  GET_ACTIVITIES_DASHBOARD,
  GET_ACTIVITY_DASHBOARD,
  DELETE_ACTIVITY,
  DELETE_VISUALIZATION,
  DELETE_PANIC_BUTTON_PULSATION,
  SET_LOADING_ACTIVITY_DASHBOARD,
  GET_GENDER_DASHBOARD,
  SET_LOADING_GENDER_DASHBOARD,
  GET_APP_INFO_DASHBOARD,
  SET_APP_INFO_LOADING_DASHBOARD,
  GET_USERS_DEPARTMENTS_DASHBOARD,
  SET_USER_DEPARTMENT_LOADING_DASHBOARD,
  GET_USER_MUNICIPALITIES_DASHBOARD,
  SET_USER_MUNICIPALITY_LOADING_DASHBOARD,
  GET_USERS_AGE_DASHBOARD,
  SET_USER_AGE_LOADING_DASHBOARD,
  GET_USER_AGE_MUNICIPALITIES_DASHBOARD,
  SET_USER_AGE_MUNICIPALITY_LOADING_DASHBOARD,
  GET_BTN_PANIC_PULSATIONS_DASHBOARD,
  SET_BTN_PANIC_PULSATIONS_LOADING_DASHBOARD,
  GET_MOST_VIEWED_SCREENS_DASHBOARD,
  SET_MOST_VIEWED_SCREENS_LOADING_DASHBOARD,
  GET_TIME_ACTIVITY_DEPARTMENT_DASHBOARD,
  SET_TIME_ACTIVITY_DEPARTMENT_LOADING_DASHBOARD,
  GET_BTN_PANIC_PULSATIONS_DEPARTMENT_DASHBOARD,
  SET_BTN_PANIC_PULSATIONS_DEPARTMENT_LOADING_DASHBOARD,
  GET_MOST_VIEWED_SCREENS_DEPARTMENT_DASHBOARD,
  SET_MOST_VIEWED_SCREENS_DEPARTMENT_LOADING_DASHBOARD,
  GET_MARKERS_PANIC_BTN_DEPARTMENT_DASHBOARD,
  SET_MARKER_BTN_PANIC_DEPARTMENT_LOADING_DASHBOARD,
  SET_DEPARTMENT_ID,
  SET_START_DATE_DASHBOARD,
  SET_END_DATE_DASHBOARD,
  SET_START_DATE_DEPARTMENT_DASHBOARD,
  SET_END_DATE_DEPARTMENT_DASHBOARD,
  SET_START_DATE_MARKER_MAP_DASHBOARD,
  SET_END_DATE_MARKER_MAP_DASHBOARD,
  DASHBOARD_ERROR,
  CLEAR_ERRORS_DASHBOARD,
  CLEAR_DATA_DASHBOARD,
} from '../types';

export default (state, action) => {
  switch (action.type) {
    case GET_ACTIVITIES_DASHBOARD:
      return {
        ...state,
        activities: action.payload,
        activityLoading: false,
        activityError: null,
      };
    case GET_ACTIVITY_DASHBOARD:
      return {
        ...state,
        activity: action.payload,
        activityLoading: false,
        activityError: null,
      };
    case GET_GENDER_DASHBOARD:
      return {
        ...state,
        gender: action.payload,
        genderLoading: false,
        genderError: null,
      };
    case GET_APP_INFO_DASHBOARD:
      return {
        ...state,
        app: action.payload,
        appLoading: false,
        appError: null,
      };
    case GET_USERS_DEPARTMENTS_DASHBOARD:
      return {
        ...state,
        userDepartments: action.payload,
        userDepartmentLoading: false,
        userDepartmentError: null,
      };
    case GET_USERS_AGE_DASHBOARD:
      return {
        ...state,
        userAges: action.payload,
        userAgeLoading: false,
        userAgeError: null,
      };
    case GET_BTN_PANIC_PULSATIONS_DASHBOARD:
      return {
        ...state,
        btnPanicPulsations: action.payload,
        btnPanicPulsationLoading: false,
        btnPanicPulsationError: null,
      };
    case GET_MOST_VIEWED_SCREENS_DASHBOARD:
      return {
        ...state,
        mostViewedScreens: action.payload,
        mostViewedScreenLoading: false,
        mostViewedScreenError: null,
      };
    case GET_USER_MUNICIPALITIES_DASHBOARD:
      return {
        ...state,
        userMunicipalities: action.payload,
        userMunicipalityLoading: false,
        userMunicipalityError: null,
      };
    case GET_USER_AGE_MUNICIPALITIES_DASHBOARD:
      return {
        ...state,
        userAgeMunicipalities: action.payload,
        userAgeMunicipalityLoading: false,
        userAgeMunicipalityError: null,
      };
    case GET_TIME_ACTIVITY_DEPARTMENT_DASHBOARD:
      return {
        ...state,
        timeActivityDepartment: action.payload,
        timeActivityDepartmentLoading: false,
        timeActivityDepartmentError: null,
      };
    case GET_BTN_PANIC_PULSATIONS_DEPARTMENT_DASHBOARD:
      return {
        ...state,
        btnPanicPulsationsDepartment: action.payload,
        btnPanicPulsationDepartmentLoading: false,
        btnPanicPulsationDepartmentError: null,
      };
    case GET_MOST_VIEWED_SCREENS_DEPARTMENT_DASHBOARD:
      return {
        ...state,
        mostViewedScreensDepartment: action.payload,
        mostViewedScreenDepartmentLoading: false,
        mostViewedScreenDepartmentError: null,
      };
    case GET_MARKERS_PANIC_BTN_DEPARTMENT_DASHBOARD:
      return {
        ...state,
        markersPanicBtnDepartment: action.payload,
        markerPanicBtnDepartmentLoading: false,
      };
    case DELETE_ACTIVITY:
    case DELETE_VISUALIZATION:
    case DELETE_PANIC_BUTTON_PULSATION:
      return {
        ...state,
        activityLoading: false,
      };
    case SET_LOADING_ACTIVITY_DASHBOARD:
      return {
        ...state,
        activityLoading: true,
      };
    case SET_LOADING_GENDER_DASHBOARD:
      return {
        ...state,
        genderLoading: true,
      };
    case SET_APP_INFO_LOADING_DASHBOARD:
      return {
        ...state,
        appLoading: true,
      };
    case SET_USER_DEPARTMENT_LOADING_DASHBOARD:
      return {
        ...state,
        userDepartmentLoading: true,
      };
    case SET_USER_MUNICIPALITY_LOADING_DASHBOARD:
      return {
        ...state,
        userMunicipalityLoading: true,
      };
    case SET_USER_AGE_LOADING_DASHBOARD:
      return {
        ...state,
        userAgeLoading: true,
      };
    case SET_USER_AGE_MUNICIPALITY_LOADING_DASHBOARD:
      return {
        ...state,
        userAgeMunicipalityLoading: true,
      };
    case SET_BTN_PANIC_PULSATIONS_LOADING_DASHBOARD:
      return {
        ...state,
        btnPanicPulsationLoading: true,
      };
    case SET_MOST_VIEWED_SCREENS_LOADING_DASHBOARD:
      return {
        ...state,
        mostViewedScreenLoading: true,
      };
    case SET_TIME_ACTIVITY_DEPARTMENT_LOADING_DASHBOARD:
      return {
        ...state,
        timeActivityDepartmentLoading: true,
      };
    case SET_BTN_PANIC_PULSATIONS_DEPARTMENT_LOADING_DASHBOARD:
      return {
        ...state,
        btnPanicPulsationDepartmentLoading: true,
      };
    case SET_MOST_VIEWED_SCREENS_DEPARTMENT_LOADING_DASHBOARD:
      return {
        ...state,
        mostViewedScreenDepartmentLoading: true,
      };
    case SET_MARKER_BTN_PANIC_DEPARTMENT_LOADING_DASHBOARD:
      return {
        ...state,
        markerPanicBtnDepartmentLoading: true,
      };
    case DASHBOARD_ERROR:
      const { type, error } = action.payload;
      switch (type) {
        case 'app':
          return {
            ...state,
            appError: error,
            appLoading: false,
          };
        case 'activity':
          return {
            ...state,
            activityError: error,
            activityLoading: false,
          };
        case 'gender':
          return {
            ...state,
            genderError: error,
            genderLoading: false,
          };
        case 'department':
          return {
            ...state,
            userDepartmentError: error,
            userDepartmentLoading: false,
          };
        case 'age':
          return {
            ...state,
            userAgeError: error,
            userAgeLoading: false,
          };
        case 'panic':
          return {
            ...state,
            btnPanicPulsationError: error,
            btnPanicPulsationLoading: false,
          };
        case 'screens':
          return {
            ...state,
            mostViewedScreenError: error,
            mostViewedScreenLoading: false,
          };
        case 'municipality':
          return {
            ...state,
            userMunicipalityError: error,
            userMunicipalityLoading: false,
          };
        case 'ageMunicipality':
          return {
            ...state,
            userAgeMunicipalityError: error,
            userAgeMunicipalityLoading: false,
          };
        case 'timeDepartment':
          return {
            ...state,
            timeActivityDepartmentError: error,
            timeActivityDepartmentLoading: false,
          };
        case 'panicDepartment':
          return {
            ...state,
            btnPanicPulsationDepartmentError: error,
            btnPanicPulsationDepartmentLoading: false,
          };
        case 'screensDepartment':
          return {
            ...state,
            mostViewedScreenDepartmentError: error,
            mostViewedScreenDepartmentLoading: false,
          };
        default:
          return {
            ...state,
            activityLoading: false,
            genderLoading: false,
            appLoading: false,
            userDepartmentLoading: false,
            userAgeLoading: false,
            userMunicipalityLoading: false,
            userAgeMunicipalityLoading: false,
            btnPanicPulsationLoading: false,
            mostViewedScreenLoading: false,
            timeActivityDepartmentLoading: false,
            btnPanicPulsationDepartmentLoading: false,
            mostViewedScreenDepartmentLoading: false,
            markerPanicBtnDepartmentLoading: false,
          };
      }
    case CLEAR_ERRORS_DASHBOARD:
      return {
        ...state,
        appError: null,
        activityError: null,
        genderError: null,
        userDepartmentError: null,
        userAgeError: null,
        btnPanicPulsationError: null,
        mostViewedScreenError: null,
        userMunicipalityError: null,
        userAgeMunicipalityError: null,
        timeActivityDepartmentError: null,
        btnPanicPulsationDepartmentError: null,
        mostViewedScreenDepartmentError: null,
      };
    case SET_DEPARTMENT_ID:
      return {
        ...state,
        departmentId: action.payload,
      };
    case SET_START_DATE_DASHBOARD:
      return {
        ...state,
        startDateDashboard: action.payload,
      };
    case SET_END_DATE_DASHBOARD:
      return {
        ...state,
        endDateDashboard: action.payload,
      };
    case SET_START_DATE_DEPARTMENT_DASHBOARD:
      return {
        ...state,
        startDateDepartment: action.payload,
      };
    case SET_END_DATE_DEPARTMENT_DASHBOARD:
      return {
        ...state,
        endDateDepartment: action.payload,
      };
    case SET_START_DATE_MARKER_MAP_DASHBOARD:
      return {
        ...state,
        startDateMarkerMap: action.payload,
      };
    case SET_END_DATE_MARKER_MAP_DASHBOARD:
      return {
        ...state,
        endDateMarkerMap: action.payload,
      };
    case CLEAR_DATA_DASHBOARD:
      return {
        activities: [],
        activity: {},
        activityLoading: true,
        gender: {},
        genderLoading: true,
        app: {},
        appLoading: true,
        userDepartments: [],
        userDepartmentLoading: true,
        userAges: [],
        userAgeLoading: true,
        appError: null,
        activityError: null,
        genderError: null,
        userDepartmentError: null,
        userAgeError: null,
        btnPanicPulsationError: null,
        mostViewedScreenError: null,
        userMunicipalityError: null,
        userAgeMunicipalityError: null,
        timeActivityDepartmentError: null,
        btnPanicPulsationDepartmentError: null,
        mostViewedScreenDepartmentError: null,
        userMunicipalities: [],
        userMunicipalityLoading: true,
        userAgeMunicipalities: [],
        userAgeMunicipalityLoading: true,
        btnPanicPulsations: {},
        btnPanicPulsationLoading: true,
        mostViewedScreens: [],
        mostViewedScreenLoading: true,
        timeActivityDepartment: {},
        timeActivityDepartmentLoading: true,
        btnPanicPulsationsDepartment: {},
        btnPanicPulsationDepartmentLoading: true,
        mostViewedScreensDepartment: [],
        mostViewedScreenDepartmentLoading: true,
        markersPanicBtnDepartment: [],
        markerPanicBtnDepartmentLoading: false,
        departmentId: null,
        startDateDashboard: moment('2022-05-14').format('YYYY-MM-DD'),
        endDateDashboard: moment().format('YYYY-MM-DD'),
        startDateDepartment: moment('2022-05-14').format('YYYY-MM-DD'),
        endDateDepartment: moment().format('YYYY-MM-DD'),
        startDateMarkerMap: moment('2022-05-14').format('YYYY-MM-DD'),
        endDateMarkerMap: moment().format('YYYY-MM-DD'),
      };
    default:
      return state;
  }
};
